/**
 * @license
 * Copyright 2020 Google Inc.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @internal
 */
export const PUPPETEER_REVISIONS = Object.freeze({
  chrome: '143.0.7499.192',
  'chrome-headless-shell': '143.0.7499.192',
  firefox: 'stable_146.0.1',
});
